import { refreshToken } from "@/Services/TherapyApi/Auth";

import { useAuthStore } from "@/Modules/Auth/Store";

import { danger, log } from "@/Utils/Debug";
import { isValidString } from "@/Utils/String";

let pendingRefresh: Promise<boolean> | null = null;

function refreshTokenAH(): Promise<boolean> {
  if (!pendingRefresh) {
    pendingRefresh = refresh().finally(() => {
      pendingRefresh = null;
    });
  }

  return pendingRefresh;
}

async function refresh(): Promise<boolean> {
  log("Refresh token");
  const authStore = useAuthStore();
  const token = authStore.userToken ?? "";

  try {
    if (isValidString(token)) {
      const refreshTokenApiResponse = await refreshToken(token);

      if (authStore.userToken !== token) {
        return false;
      }

      authStore.setUserToken(refreshTokenApiResponse.token);

      log("Refresh token success");

      return true;
    } else {
      return handleError();
    }
  } catch (error: unknown) {
    if (authStore.userToken !== token) {
      return false;
    }

    return handleError(error);
  }
}

function handleError(error?: unknown): boolean {
  const authStore = useAuthStore();

  log("Refresh token failed");
  danger("Error refresh token", error);
  authStore.logout();

  return false;
}

export default refreshTokenAH;
